@if (this.state !== 'ACTIVE') {
  <div [class]="this.getClass()" class="p-3 mb-2 text-center">
    @if (this.state === 'NONE') {
      <div>
        Vous n'avez pas d'abonnement actif.
        <a class="btn btn-sm btn-primary" routerLink="/organization/billing">Cliquez
        ici pour vous abonner ou commencer votre essai gratuit.</a>
      </div>
    }
    @if (this.state === 'SUSPENDED') {
      <div>
        Votre abonnement est suspendu.
        <a class="btn btn-sm btn-primary" routerLink="/organization/billing/subscription/upgrade">
          <strong>Recommencer l'abonnement.</strong>
        </a>
      </div>
    }
    @if (this.state === 'FREE_TRIAL') {
      <div>
        Il reste {{ freeTrialDaysLeft }} jours à votre essai gratuit.
        <a class="btn btn-sm btn-white" routerLink="/organization/billing">
          <strong>S'abonner maintenant</strong>
        </a>
      </div>
    }
    @if (this.state === 'FREE_TRIAL_LESS_THAN_7_DAYS_LEFT') {
      <div>
        Il ne reste que {{ freeTrialDaysLeft }} jours à votre essai gratuit.
        <a class="btn btn-sm btn-white" routerLink="/organization/billing">Abonnez-vous maintenant</a>
      </div>
    }
    @if (this.state === 'FREE_TRIAL_LESS_THAN_3_DAYS_LEFT') {
      <div>
        Il ne reste que {{ freeTrialDaysLeft }} jours à votre essai gratuit. Évitez les interruptions de service et
        <a class="btn btn-sm btn-primary" routerLink="/organization/billing">
          <strong>Abonnez-vous maintenant</strong>
        </a>
      </div>
    }
    @if (this.state === 'FREE_TRIAL_OVER') {
      <div>
        Votre essai gratuit est terminé. Pour continuer à utiliser Optitax,
        <a class="btn btn-sm btn-primary" routerLink="/organization/billing">
          <strong>Abonnez-vous maintenant</strong>
        </a>
      </div>
    }
    @if (this.state === 'LESS_THAN_7_DAYS_LEFT') {
      <div>Nous n'avons pu procéder au paiement. Votre abonnement vient à
        expiration dans moins de 7 jours. Évitez les interruptions de service et
        <a class="btn btn-sm btn-primary" routerLink="/organization/billing">
          <strong>Recommencer votre abonnement.</strong>
        </a>
      </div>
    }
    @if (this.state === 'LESS_THAN_3_DAYS_LEFT') {
      <div>
        Nous n'avons pu procéder au paiement. Votre abonnement se termine dans moins de 3 jours.
        <a class="btn btn-sm btn-primary" routerLink="/organization/billing/subscription/upgrade">
          <strong>Recommencer l'abonnement.</strong>
        </a>
      </div>
    }
  </div>
}
